export function enforceFilesDomain(path?: string) {
  // if nothing or undefined, return that back
  if (!path) {
    return path;
  }

  // check if path is a full url already
  const valid = isValidUrlV2(path);
  if (valid) {
    return path;
  }

  // join files domain with relative path
  const domain = getEnv("VITE_FILES_DOMAIN");
  const attempt = `${trailingSlashIt(domain)}${unLeadingSlashIt(path)}`;

  // validate this is a url
  const validAttempt = isValidUrlV2(attempt);
  if (validAttempt) {
    return attempt;
  }

  // if nothing else, return what was provided
  return path;
}
